import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianAxis,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  Flex,
  Heading,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

const WeeklyEarningChart = ({ data }) => {
  const noDataBgColor = useColorModeValue("#fff", "#081b2e");
  const modeBg = useColorModeValue("#fff", "#030c1b");
  const [weeklyData, setWeeklyData] = useState();
  const [weeklyTotalAmount, setWeeklyTotalAmount] = useState(0);

  //calculate weekly data
  const calculateWeeklyData = (earningsData) => {
    const weekdays = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const currentDate = new Date();
    const currentWeekNumber = getWeekNumber(currentDate); // Implement getWeekNumber function //35th week of the year
    const weeklyAmounts = {};

    earningsData?.forEach((entry) => {
      const date = new Date(entry.created_at);
      const dayOfWeekIndex = date.getDay(); // Get the index of the day (0-6)
      const dayOfWeek = weekdays[dayOfWeekIndex];
      const weekNumber = getWeekNumber(date); // Implement getWeekNumber function
      const amount = parseFloat(entry.amount);

      if (!isNaN(amount) && weekNumber === currentWeekNumber) {
        if (weeklyAmounts[dayOfWeek]) {
          weeklyAmounts[dayOfWeek] += amount;
        } else {
          weeklyAmounts[dayOfWeek] = amount;
        }
      }
    });
    const formattedWeeklyData = weekdays.map((day, index) => ({
      day,
      amount: weeklyAmounts[day]?.toString() || "0",
    }));
    return formattedWeeklyData; //[{'day': 'monday', 'amount':'1000'}, {'day': 'tuesday', 'amount':'1000'}]
  };

  useEffect(() => {
    setWeeklyData(calculateWeeklyData(data));
    console.log("weeklyData:", weeklyData);
  }, [data]);

  const sortedWeeklyData = weeklyData?.sort((a, b) => {
    const weekdays = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    return weekdays.indexOf(a.day) - weekdays.indexOf(b.day);
  });

  const totalSum = sortedWeeklyData?.reduce((sum, entry) => {
    const finalSum = sum + parseFloat(entry.amount);
    return finalSum;
  }, 0);

  const formattedTotalSum = formatAmount(totalSum);

  function formatAmount(amount) {
    if (amount >= 1000000) {
      return (amount / 1000000).toFixed(1) + "m";
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(1) + "k";
    }
    return amount?.toString();
  }

  // to help total sum of the current week only,
  function getWeekNumber(date) {
    const target = new Date(date.valueOf());
    const dayNr = (date.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    const firstThursday = target.valueOf();
    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
      target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7));
    }
    return 1 + Math.ceil((firstThursday - target) / 604800000); // 604800000 ms = 7 days
  }

  const noDataStyles = {
    p: "10px",
    borderRadius: "5px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: noDataBgColor,
    w: "100%",
    fontSize: ".9em",
  };

  return (
    <>
      {formattedTotalSum > 0 ? (
        <Stack direction={"row"} mb="20px" justifyContent={"space-between"}>
          <Stack direction={"column"} gap={20}>
            <Heading fontSize="1.5em">Weekly Earnings</Heading>
            <Heading>${formattedTotalSum}</Heading>
          </Stack>

          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={weeklyData}
              margin={{
                top: 10,
                left: 20,
                right: 20,
                bottom: 10,
              }}
            >
              <CartesianGrid strokeDasharray="3 3"></CartesianGrid>
              <XAxis
                dataKey="day"
                tickFormatter={(day) => day[0].toUpperCase() + day.slice(1)} // Capitalize the day labels
              />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="day" fill="green"></Bar>
              <Bar dataKey="amount" fill="#4f46ba"></Bar>
            </BarChart>
          </ResponsiveContainer>
        </Stack>
      ) : (
        <Stack
          direction={"column"}
          mb="20px"
          justifyContent={"center"}
          {...noDataStyles}
        >
          <Heading fontSize="1.5em">Weekly Earnings</Heading>

          <Text textAlign={"center"}>No data at the moment</Text>
        </Stack>
      )}
    </>
  );
};

export default WeeklyEarningChart;
